// extracted by mini-css-extract-plugin
export var grid = "_30-0";
export var span1 = "_30-2";
export var span10 = "_30-b";
export var span10L = "_30-z";
export var span10M = "_30-n";
export var span10Xl = "_30-1b";
export var span11 = "_30-c";
export var span11L = "_30-10";
export var span11M = "_30-o";
export var span11Xl = "_30-1c";
export var span12 = "_30-d";
export var span12L = "_30-11";
export var span12M = "_30-p";
export var span12Xl = "_30-1d";
export var span1L = "_30-q";
export var span1M = "_30-e";
export var span1Xl = "_30-12";
export var span2 = "_30-3";
export var span2L = "_30-r";
export var span2M = "_30-f";
export var span2Xl = "_30-13";
export var span3 = "_30-4";
export var span3L = "_30-s";
export var span3M = "_30-g";
export var span3Xl = "_30-14";
export var span4 = "_30-5";
export var span4L = "_30-t";
export var span4M = "_30-h";
export var span4Xl = "_30-15";
export var span5 = "_30-6";
export var span5L = "_30-u";
export var span5M = "_30-i";
export var span5Xl = "_30-16";
export var span6 = "_30-7";
export var span6L = "_30-v";
export var span6M = "_30-j";
export var span6Xl = "_30-17";
export var span7 = "_30-8";
export var span7L = "_30-w";
export var span7M = "_30-k";
export var span7Xl = "_30-18";
export var span8 = "_30-9";
export var span8L = "_30-x";
export var span8M = "_30-l";
export var span8Xl = "_30-19";
export var span9 = "_30-a";
export var span9L = "_30-y";
export var span9M = "_30-m";
export var span9Xl = "_30-1a";
export var stretch = "_30-1";